import React from 'react';
import PrivateLayout from '../../../layouts/private';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import SubscriptionStatusComponent from './subscription-status-component';

class SubscriptionStatusScreen extends React.Component {

    render() {
        return (
            <PrivateLayout screenTitle="Your Subscription Status">
                <div className="lz-full-bg-wrapper">
                    <Paper elevation={2} style={{ paddingTop: 24, paddingBottom: 24 }}>
                        <Container>

                            <SubscriptionStatusComponent />

                        </Container>
                    </Paper>
                </div>
            </PrivateLayout>
        );
    }

}

export default SubscriptionStatusScreen;
